import { ProjectPermissions } from "shared/types/__generated__/graphql"

export type { ProjectPermissions }

export const ProjectPermissionsTypename = "ProjectPermissions" as const

export enum ProjectPermissionType {
  VIEW = "view_project",
  EDIT = "edit_project",
  EDIT_PRICE = "edit_position_price",
  EDIT_PRICE_GROUP = "edit_position_price_group",
  CREATE_SPECIAL_PRICE_GROUP = "create_special_price_group",
  INVITE_MEMBERS = "invite_members",
  DELETE = "delete_project"
}

export const readonlyProjectPermissions: ProjectPermissions = {
  [ProjectPermissionType.VIEW]: true,
  [ProjectPermissionType.EDIT]: false,
  [ProjectPermissionType.EDIT_PRICE]: false,
  [ProjectPermissionType.EDIT_PRICE_GROUP]: false,
  [ProjectPermissionType.CREATE_SPECIAL_PRICE_GROUP]: false,
  [ProjectPermissionType.INVITE_MEMBERS]: false,
  [ProjectPermissionType.DELETE]: false,
  __typename: ProjectPermissionsTypename
}

export const fullProjectPermissions: ProjectPermissions = {
  [ProjectPermissionType.VIEW]: true,
  [ProjectPermissionType.EDIT]: true,
  [ProjectPermissionType.EDIT_PRICE]: true,
  [ProjectPermissionType.EDIT_PRICE_GROUP]: true,
  [ProjectPermissionType.CREATE_SPECIAL_PRICE_GROUP]: true,
  [ProjectPermissionType.INVITE_MEMBERS]: true,
  [ProjectPermissionType.DELETE]: true,
  __typename: ProjectPermissionsTypename
}
